/**
 * @file: 询价中图标
 * icon-xunjiazhong
 * https://www.iconfont.cn/manage/index?spm=a313x.7781069.1998910419.13&manage_type=myprojects&projectId=721231&keyword=&project_type=&page=
 *
 * @author: FJJ
 * @history:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2023/03/02      1.0     First version
 *
 * Copyright 2022, all rights reserved. Essa.cn
 * */
import React  from "react";
const IconXunjiazhong = ({size=14}) => {
        return (
            <img className="iconfont" width={size}
                src={"https://oss.essaone.com/3689db37-203e-4d5d-af64-b886d3b4042d.svg"}></img>
        );
}

export default IconXunjiazhong;
